<template>
  <v-row>
    <v-col cols="11" sm="5">
      <v-dialog ref="dialogA" v-model="modal" :return-value.sync="date" persistent width="290px">
        <template v-slot:activator="{ on, attrs }">
          <v-text-field v-model="picker" :label="datePickerText" prepend-icon="mdi-calendar" readonly v-bind="attrs"
            v-on="on"></v-text-field>
        </template>
        <v-date-picker v-if="modal" v-bind:min="minDate" :change="dateTimeChange()" v-model="picker" locale="fr-FR">
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="modal = false"> Cancel </v-btn>
          <v-btn text color="primary" @click="$refs.dialogA.save(date)">
            OK
          </v-btn>
        </v-date-picker>
      </v-dialog>
    </v-col>
    <v-spacer></v-spacer>
    <v-col cols="11" sm="5">
      <v-dialog ref="dialog" v-model="modal2" :return-value.sync="time" persistent width="290px">
        <template v-slot:activator="{ on, attrs }">
          <v-text-field v-model="time" v-bind:label="timePickerText" prepend-icon="mdi-clock-time-four-outline" readonly
            v-bind="attrs" v-on="on"></v-text-field>
        </template>
        <v-time-picker v-if="modal2" v-model="time" full-width format="24hr" :change="dateTimeChange()">
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="modal2 = false">
            {{ cancelText }}
          </v-btn>
          <v-btn text color="primary" @click="$refs.dialog.save(time)">
            {{ okText }}
          </v-btn>
        </v-time-picker>
      </v-dialog>
    </v-col>
    <v-col>
      <v-btn :disabled="!isButtonActive" @click="send"> Send noSleep </v-btn>
    </v-col>
  </v-row>
</template>
<script>
export default {
  data: () => ({
    date: null,
    picker: null, // data of date picker
    time: null, // data of time picker
    //for the UI
    menu2: false,
    modal2: false,
    modal: false,
    datePickerText: "Scheduled wake up date",
    timePickerText: "Scheduled wake up time",
    minTime: null,
    minDate: new Date().toISOString(),
    timeToSend: null,
    cancelText: null,
    okText: null,
    isButtonActive: false,
  }),
  methods: {
    formatDateTimeToSend: function (dateTime) {
      let dt = dateTime;
      return `${dt.getDate().toString().padStart(2, "0")}/${(dt.getMonth() + 1)
        .toString()
        .padStart(2, "0")}/${dt
          .getFullYear()
          .toString()
          .padStart(4, "0")} ${dt
            .getHours()
            .toString()
            .padStart(2, "0")}:${dt
              .getMinutes()
              .toString()
              .padStart(2, "0")}:${dt.getSeconds().toString().padStart(2, "0")}`;
    },
    send: function () {
      this.$emit("sendNoSleep", this.timeToSend);
    },
    dateTimeChange() {
      let dt = new Date(this.picker + "T" + this.time);
      this.timeToSend = this.formatDateTimeToSend(dt);
      if (dt instanceof Date && !isNaN(dt.valueOf())) { // is valid dateTime
        this.isButtonActive = true
      }
    },
  },
  mounted: function () {
    this.cancelText = "CANCEL";
    this.okText = "OK";
  },
};
</script>